import Service from '@/helpers/service'

export default {
    getMaximumFile() {
        return Service().get('MaximumFile');
    },
    updateMaximumFile(params){
        return Service().post('MaximumFile/update', params)
    }
}